import { getCurrentInstance } from 'vue'
import { useAsyncWrapper } from './useAsyncWrapper'
import { useContentLocale } from './useContentLocale'
import { useI18n } from './useI18N'
import { useRouteParams } from './useRouteParams'
import { useToast } from './useToast'

export const useUtilityHelpers = () => {
  const toast = useToast()

  const router = useRouteParams()

  const i18n = useI18n()

  const contentLocale = useContentLocale()

  const asyncWrapper = useAsyncWrapper()

  return {
    ...asyncWrapper,
    ...contentLocale,
    ...router,
    ...toast,
    getCurrentInstance,
    i18n,
  }
}
